const languages = ['en', 'ru', 'ua']

export const Languages = Object.defineProperties(
	{},
	languages.reduce(
		(_, value) => Object.assign(_, {
			[value]: {
				enumerable: true,
				value,
				writable: false
			}
		}),
		{
			values: {
				get: () => [ ...languages ]
			},
			default: {
				get: () => languages[0]
			}
		}
	)
)
